var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138px",
    height: "109px",
    viewBox: "0 0 138 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 138 0 138 109 0 109"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-No-Internet",
    transform: "translate(-119.000000, -237.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error2",
    transform: "translate(101.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36744,23.762 C117.265859,8.938 94.2376303,0 69.0432459,0 C43.8458446,0 20.820633,8.938 2.7190516,23.762 C-0.611639384,26.5233333 -0.973671012,31.5373333 2.13980099,34.662 L63.9717862,96.6466667 C66.7956329,99.4806667 71.3602483,99.4806667 74.184095,96.6466667 L105.246409,65.4 L105.246409,32.7 L137.177598,32.7 C138.698131,29.7206667 138.118881,26.0146667 135.36744,23.762 M121.537832,98.1 C118.569173,98.1 116.104341,100.570667 116.104341,103.553028 C116.104341,106.529333 118.569173,109 121.537832,109 C124.503474,109 126.968306,106.529333 126.968306,103.553028 C126.968306,100.570667 124.503474,98.1 121.537832,98.1 M126.968306,49.05 L126.968306,82.1133333 C126.968306,85.0926667 124.503474,87.5633333 121.537832,87.5633333 C118.569173,87.5633333 116.104341,85.0926667 116.104341,82.1133333 L116.104341,49.05 C116.104341,46.0706667 118.569173,43.6 121.537832,43.6 C124.503474,43.6 126.968306,46.0706667 126.968306,49.05",
    id: "Fill-1",
    fill: "#E0E0E0",
    mask: "url(#mask-2)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkError);
export default __webpack_public_path__ + "static/media/network_error.c868da09.svg";
export { ForwardRef as ReactComponent };